import CounterfeitTable from "./counterfeitTable.container";

export default CounterfeitTable;